import React from 'react';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';

import immutableToJS from 'utils/immutableToJS';

import { userSelector } from 'features/authentication/redux/selectors';

import {
  setComponentExpanded as setComponentExpandedAction,
  updateScrollToUnreadNote,
} from 'redux/ui/actions';

import {
  currentServiceRequestSelector,
} from 'redux/serviceRequests/selectors';

import {
  actionBarItemClickedSelector,
  componentsExpandedSelector,
  scrollToUnreadNoteSelector,
} from 'redux/ui/selectors';

import NotesPropTypes from './PropTypes';

/* istanbul ignore next */
const withConnectedData = (WrappedComponent) => {
  function Container(props) {
    return (
      <WrappedComponent {...props} />
    );
  }

  Container.propTypes = NotesPropTypes;

  Container.defaultProps = {
    actionBarItemClicked: {},
    info: {},
    notes: {
      requesting: false,
      error: null,
      data: [],
    },
    availableRecipients: {
      requesting: false,
      error: null,
      data: [],
    },
    scrollToUnreadNote: false,
  };

  function mapStateToProps(state) {
    return {
      actionBarItemClicked: actionBarItemClickedSelector(state),
      currentUser: userSelector(state),
      info: currentServiceRequestSelector(state),
      // TODO: Future implementation just add the contextual data refer to CaseNotesContainer
      // notes: currentServiceRequestNotes(state),
      // availableRecipients: currentRecipientsSelector(state),
      componentsExpanded: componentsExpandedSelector(state),
      scrollToUnreadNote: scrollToUnreadNoteSelector(state),
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      // TODO: Future Implementation just add the contextual actions
      clearAvailableRecipients: () => console.log('TODO: message'),
      loadNotes: () => console.log('TODO: message'),
      loadAvailableRecipients: () => console.log('TODO: message'),
      postNote: () => console.log('TODO: message'),
      setNotes: () => console.log('TODO: message'),
      updateNote: () => console.log('TODO: message'),
      setComponentExpanded: (expandKey, expanded) =>
        dispatch(setComponentExpandedAction({ expandKey, expanded })),
      updateScrollToUnreadNote: bool => dispatch(updateScrollToUnreadNote(bool)),
    };
  }

  return compose(
    setDisplayName('ServiceRequestNotesContainer'),
    connect(mapStateToProps, mapDispatchToProps),
    immutableToJS,
  )(Container);
};

export default withConnectedData;



// WEBPACK FOOTER //
// ./compositions/NotesWidget/ServiceRequestNotesContainer.js